<template>
  <v-app>
    <Head></Head>
    <v-content app>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Head from '@/components/site/Head'
export default {
  name: 'App',
  metaInfo: {
    title: 'SpeechAssessment',
    htmlAttrs: {
      lang: 'ru'
    }
  },
  components: {
    Head
  },

  data: () => ({
    //
  }),

  methods: {
    async initialApp () {
      this.$store.commit('loginInitial')
      await this.$store.dispatch({
        type: 'speakerRequest'
      })
      await this.$store.dispatch('initialSpeech')
      await this.$store.dispatch('initialTribune')
    }
  },

  created () {
    this.initialApp()
  }
}
</script>

<style lang="scss">
  @import '@/assets/colors';
</style>
